import { BsTrash } from "react-icons/bs";
import ActionButtonWithIcon from "../Common/ActionButtonWithIcon";
import { useTranslation } from "react-i18next";
interface Props {
    onClick: () => void;
    disabled?: boolean;
}

export const ClearChatButton = ({ disabled, onClick }: Props) => {
    const { t } = useTranslation("translation", { keyPrefix: "chat" });
    return <ActionButtonWithIcon text={t("deleteConversation")} icon={BsTrash} onClick={onClick} buttonProps={{ disabled: disabled }} />;
};
